import React from 'react';

import { useLocation } from 'react-router-dom';
import {
  SocialButtonContainer,
  SociaButtonTitle,
} from '../styles';

import {
  GoogleButtonIcon,
  GoogleImage,
} from './styles';

const GOOGLE_BUTTON = {
  bg: '#FFFFFF',
  border: '#747775',
  color: '#1F1F1F',
  name: 'Google',
};

const SocialButton = () => {
  const {
    bg,
    name,
    border,
    color,
  } = GOOGLE_BUTTON;

  const { pathname } = useLocation();

  const signText = pathname.includes('sign-up') ? 'Sign Up' : 'Sign In';
  const buttonText = `${signText} with ${name}`;

  const handleClick = () => {
    const [googleBtn] = document.querySelectorAll('[data-oauth-command="googleidentity.call"]');
    if (googleBtn) googleBtn.click();
  };

  return (
    <SocialButtonContainer
      bg={bg}
      border={border}
      onClick={handleClick}
      provider="googleidentity"
    >
      <GoogleButtonIcon>
        <GoogleImage src="/images/g-logo.svg" />
      </GoogleButtonIcon>
      <SociaButtonTitle
        color={color}
      >
        {buttonText}
      </SociaButtonTitle>
    </SocialButtonContainer>
  );
};

export default SocialButton;
